import * as z from "zod";

const AeoPromptResponseSchema_ = z.object({
  id: z.bigint(),
  promptResponseId: z.bigint(),
  model: z.string(),
  timestamp: z.string(),
  contentPreview: z.string(),
  brandMentions: z.number(),
});

export const AeoPromptResponseSchema: z.ZodType<AeoPromptResponseSchema> =
  AeoPromptResponseSchema_;
export interface AeoPromptResponseSchema extends z.infer<
  typeof AeoPromptResponseSchema_
> {}

export const getAeoPromptResponses = {
  name: "getAeoPromptResponses" as const,
  input: z.object({
    promptId: z.bigint(),
    dayLimit: z.number().optional(),
    dayOffset: z.number().optional(),
  }),
  output: z.object({
    responses: z.array(AeoPromptResponseSchema),
    totalDays: z.number(),
  }),
};
